import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '@/hooks';
import { CreatorsHubLayout } from './CreatorsHubLayout';
import { NetworkEntry } from '@/features/networks/NetworkEntry';

export function CreatorsHubPage() {
  return <NetworkEntry family="creator_collaboration" destination="creator" fallback={<LegacyCreatorHub />} />;
}
function LegacyCreatorHub() {
  const { isAuthenticated, isPremium } = useSession();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to={`/signin?next=${encodeURIComponent(location.pathname)}`} replace />;
  }
  if (!isPremium) {
    return <Navigate to="/premium" replace />;
  }
  return <CreatorsHubLayout />;
}
